import Kinto from 'kinto'
import KintoClient from 'kinto-http'
import Pusher from 'pusher-js'
import {
	EventBus
} from '../store/eventbus.js';

class Kintodb {
	// default options
	constructor(options) {
		this.options = {
			bucket: "default",
			remote: "https://kinto.dev.mozaws.net/v1",
			collections: {},
			credentials: {
				username: "user",
				password: "pass"
			},
			headers: {
				Authorization: "Basic"
			},
			pusher: false,
			debug: false
		}
		this.options = Object.assign(this.options, options);
		this.kintoheaders = {
			Authorization: this.options.headers.Authorization + ' ' + btoa(`${this.options.credentials.username}:${this.options.credentials.password}`)
		}
	}

	fetchServerInfo() {
		let _this = this;
		return new Promise((resolve, reject) => {
			this.client.fetchServerInfo({
				headers: this.kintoheaders
			}).then(function(result) {
				_this.serverInfo = result;
				_this.defaultBucket_id = result.user.bucket;
				resolve();
			}).catch(function(err) {
				console.log("error fetching server info", err);
				reject(error);
			});
		});
	}

	getAvailableBuckets() {
		let _this = this;
		return new Promise((resolve, reject) => {
			this.client.listBuckets({
				headers: this.kintoheaders
			}).then(function({
				data
			}) {
				_this.availableBuckets = data;
				resolve();
			}).catch(function(err) {
				console.log("error fetching buckets", err);
				reject(error);
			});
		})
	}

	connect() {
		return new Promise((resolve, reject) => {
			this.client = new KintoClient(this.options.remote)
			this.fetchServerInfo().then(() => {
				this.getAvailableBuckets().then(() => {
					resolve();
				})
			}).catch((error) => {
				console.log("kinto db connect error", error)
				reject(error);
			})
		})
	}

	init() {
		let _this = this;
		this.kinto = new Kinto({
			remote: this.options.remote,
			bucket: this.options.bucket,
			headers: this.kintoheaders,
		});
		if (_this.options.pusher) {
			var pusher_key = _this.options.pusher.pusher_key;
			var pusher = new Pusher(pusher_key, {
				cluster: 'eu',
				encrypted: true
			});
			pusher.connection.bind('connected', function() {
				console.log("PUSHER: CONNECTED");
			})
			pusher.connection.bind('unavailable', function() {
				console.warn("PUSHER: UNAVAILABLE");
			})
			pusher.connection.bind('connecting', function() {
				console.warn("PUSHER: CONNECTING");
			})
			pusher.connection.bind('connecting_in', function(delay) {
				console.warn("PUSHER: RECONNECT IN " + delay + "s");
			})
			pusher.connection.bind('state_change', function(states) {
				// states = {previous: 'oldState', current: 'newState'}
				console.warn("Pusher's state is changing from " + states.previous + " to " + states.current, states);
				if(states.current == 'connected'){
					EventBus.$emit('db:reconnected');
				}
				if(states.current == 'unavailable'){
					EventBus.$emit('db:unavailable');
				}
			});
		}
		console.log("let use Pusher", _this.options.pusher)
		this.options.collections.forEach(function(col) {
			const kintocollection = _this.kinto.collection(col, {
				localFields: ["isCurrent", "opened"]
			});
			console.log(kintocollection);
			_this[col] = kintocollection;
			if (_this.options.pusher) {
				_this.setupLiveSync(pusher, col);
			}
		});
	}

	sync() {
		console.log("sync test", this);
		//getOwnPropertyNames()
	}

	setupLiveSync(pusher, col) {
		if (this.options.bucket == "default") {
			this.fetchServerInfo().then(() => {
				this.bucketId = this.defaultBucket_id;
				this.init();
			})
		} else {
			this.bucketId = this.options.bucket;
		}
		let _this = this;

		var channelName = `${_this.bucketId}-${col}-record`;
		var channel = pusher.subscribe(channelName);

		channel.bind('create', function(data) {
			console.log("New records created", data);
			EventBus.$emit('db:change:' + col, data);
		});
		channel.bind('update', function(data) {
			console.log("Records updated", data);
			EventBus.$emit('db:change:' + col, data);
		});
		channel.bind('delete', function(data) {
			console.log("Records deleted", data);
			EventBus.$emit('db:change:' + col, data);
		});
	}
}
export default Kintodb;


// WEBPACK FOOTER //
// ./src/store/kintodb.js